/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Verify_Email_TitleInputs */



/**
* | output |
* | --- |
* | "Verify Your Email" |
*
* @param {Login_Verify_Email_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_verify_email_title = /** @type {((inputs?: Login_Verify_Email_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Verify_Email_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vérifiez Votre Email")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bestätigen Sie Ihre E-Mail-Adresse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Verifica la tua email")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подтвердите свой адрес электронной почты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Verifique su correo electrónico")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("验证您的电子邮件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メールアドレスを確認する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपना ईमेल सत्यापित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verifique seu e-mail")
	return /** @type {LocalizedString} */ ("Verify Your Email")
});